import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Icon from "@/components/common/Icon";
import { useTranslation } from "react-i18next";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation();
  const isDevelopment = import.meta.env.DEV;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: 3,
      }}
    >
      <Alert severity="error" sx={{ maxWidth: 600, mb: 3 }}>
        <AlertTitle>{t("somethingWentWrong")}</AlertTitle>
        <Typography variant="body2">{t("errorPageDescription")}</Typography>
      </Alert>

      {isDevelopment && (
        <Box
          sx={{
            maxWidth: 800,
            width: "100%",
            mb: 3,
            p: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            overflow: "auto",
          }}
        >
          <Typography
            variant="caption"
            component="pre"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {error.message}
            {"\n\n"}
            {error.stack}
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        startIcon={<Icon name="refresh-cw" size={20} />}
        onClick={resetErrorBoundary}
        size="large"
      >
        {t("tryAgain")}
      </Button>
    </Box>
  );
};

export default ErrorFallback;
